<template>
    <v-dialog v-model="show" persistent width="500">
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                <span class="headline">{{$t('projectCredentials.createApiKey')}}</span>
            </v-card-title>
            <v-container grid-list-md class="pa-3">
                <v-form @submit.prevent="submit" v-model="formValid" ref="form">
                    <v-text-field
                        v-model="name"
                        :label="$t('keyName') | capitalize"
                        :rules="formRules.required"
                        autofocus
                    ></v-text-field>
                </v-form>
            </v-container>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close()">{{$t('cancel')}}</v-btn>
                <v-btn color="warning darken-1" flat @click="submit">{{$t('create')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import CredentialsService from '@/services/credentials.service'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import DialogPromiseMixin from '@/modules/fptai/mixins/DialogPromiseMixin'

export default {
    name: 'CreateApiKey',
    mixins: [FormMixin, DialogPromiseMixin],
    data () {
        return {
            name: ''
        }
    },
    computed: {
        ...mapState({
            projects: state => state.user.projects,
            currentProjectId: state => state.user.currentProjectId
        })
    },
    methods: {
        submitValidForm () {
            if (this.formValid) {
                this.$appService.showLoading()
                let i18n = {
                    action: this.$t('create'),
                    item: 'API Key'
                }
                CredentialsService.createAPIKeys(this.currentProjectId, this.name).then(
                    result => {
                        this.$appService.hideLoading()
                        this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                        this.close()
                        this.promise.resolve(result)
                    },
                    this.$appService.handleRequestError(this.$t('actionFailed', i18n), true)
                )
            }
        }
    }
}
</script>
